<script setup lang="ts">

import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { FilterDateRange } from '@shared/ui/filters'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { AppMultiSelect } from '@shared/ui/selects'

import DisciplineFilesSendMenu from './DisciplineFilesSendMenu.vue'
import { useFiltersDisciplineFiles } from '../model/filters-discipline-files.hook'

defineOptions({
  name: 'FiltersDisciplineFiles',
})

const {
  refDateRange,
  refCategories,
  categoryOptions,
  isLoading,
  search,
  clearFilters,
} = useFiltersDisciplineFiles()
</script>

<template>
  <div class="filters-discipline-files">
    <div class="filters-discipline-files__fields">
      <FilterDateRange
        v-model="refDateRange"
        presets
        class="filters-discipline-files__date"
        label="Date"
        placeholder="Search"
        :disabled="isLoading"
      />
      <AppMultiSelect
        v-model="refCategories"
        class="filters-discipline-files__type"
        :options="categoryOptions"
        label="Type"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
      <BtnPrimary
        text="Search"
        :disabled="isLoading"
        @click="search"
      />
      <BtnIcon
        :icon="faFilterCircleXmark"
        color="red"
        tooltip-text="Clear filters"
        :disabled="isLoading"
        @click="clearFilters"
      />
    </div>
    <DisciplineFilesSendMenu />
  </div>
</template>

<style scoped lang="scss" src="./FiltersDisciplineFiles.scss" />
